import { defineStore } from "pinia";
import { api } from "@/helpers/api.js";

export const useDistributorStore = defineStore("distributor", {
  state: () => ({
    distributor: null,
    languageChanged: 0,
  }),
  actions: {
    async fetchDistributor(distributorId) {
      // issue xs2ticket https://gitlab.xs2event.com/webapps/xs2event-portal-v2/-/issues/2335
      if (!distributorId) return Promise.resolve(undefined);
      const req = api
        .cache("/distributors/" + distributorId)
        .then((res) => res.data)
        .then((data) => (this.distributor = { ...data, invoice_address: data.invoice_address || {} }));
      const res = await req;
      return res;
    },
    async saveDistributor(distributorId, data) {
      const req = api.put("/distributors/portal/" + distributorId, data);
      const res = await req;
      return res;
    },
    async patchDistributor(distributorId, patchData) {
      const res = await api.patch("/distributors/" + distributorId, patchData);
      if (res?.data && this.distributor) {
        this.distributor = {
          ...this.distributor,
          ...res.data,
          address: res.data.address ?? this.distributor.address,
          invoice_address:
            res.data.invoice_address ?? res.data.invoice_address_dto ?? this.distributor.invoice_address ?? {},
        };
      }
      return res?.data;
    },
  },
});
